import Api from "./axios";

const api = new Api();

export const getDashboardData = async () => {
    try {
        let data = await api.get("/admin/dashboard");

        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const getAllLembaga = async () => {
    try {
        let data = await api.get("/admin/lembaga");

        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const createLembaga = async (datas) => {
    try {
        let data = await api.post("/admin/lembaga/create", datas, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const importLembaga = async (datas) => {
    try {
        let data = await api.post("/data/users/import", datas, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const deleteLembaga = async (id) => {
    try {
        let data = await api.post(
            "/admin/lembaga/delete",
            { id },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};

export const updateLembaga = async (datas) => {
    try {
        let data = await api.post("/admin/lembaga/update", datas, {
            headers: {
                "Content-Type": "application/json",
            },
        });
        return data;
    } catch (error) {
        console.error(error);
        return false;
    }
};
